import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const guideLinks = [
  { name: "Anfänger Guide", url: "/guide/oopbuy-spreadsheet-anfaenger", internal: true },
  { name: "QC Guide", url: "/guide/oopbuy-spreadsheet-qc", internal: true },
  { name: "Versand Guide", url: "/guide/oopbuy-spreadsheet-versand", internal: true },
  { name: "Sneaker Guide", url: "/guide/oopbuy-spreadsheet-sneaker", internal: true },
  { name: "Coupons Guide", url: "/guide/oopbuy-spreadsheet-coupons", internal: true },
];

const resourceLinks = [
  { name: "Alle Guides (Sitemap)", url: "/sitemap", internal: true },
  { name: "OOPBUY Review", url: "https://kaspreadsheet.com", external: true },
  { name: "Best Finds 2026", url: "https://kaspreadsheet.com", external: true },
  { name: "Compare Agents", url: "https://kaspreadsheet.com", external: true },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 max-w-6xl mx-auto">
          {/* Products */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Produkte</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors"
                >
                  Alle Produkte
                </a>
              </li>
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Guides</h4>
            <ul className="space-y-2.5">
              {guideLinks.map((link) => (
                <li key={link.name}>
                  {link.internal ? (
                    <Link to={link.url} className="text-sm text-background-400 hover:text-background-200 transition-colors">
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Ressourcen</h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.name}>
                  {link.internal ? (
                    <Link to={link.url} className="text-sm text-background-400 hover:text-background-200 transition-colors">
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Info</h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-background-400">OOPBUY Spreadsheet Guide</span>
              </li>
              <li>
                <span className="text-sm text-background-400">Deutschland</span>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-200 transition-colors"
                >
                  Kontakt
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-800/50">
        <div className="w-full px-4 md:px-8 lg:px-12 py-6">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <p className="text-xs text-background-500 text-center sm:text-left">
                &copy; 2026 oopbuyspread.beer — Unabhängiger Shopping Guide für OOPBUY
              </p>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/sitemap" className="text-xs text-background-500 hover:text-background-300 transition-colors">
                Sitemap
              </Link>
              <a href="/sitemap.xml" className="text-xs text-background-500 hover:text-background-300 transition-colors">
                XML
              </a>
            </div>
          </div>
          <div className="max-w-6xl mx-auto mt-3">
            <p className="text-xs text-background-500 text-center max-w-md mx-auto">
              Disclaimer: Externe Links führen zu kaspreadsheet.com. Diese Website ist rein informativ
              und steht in keiner direkten Verbindung zu OOPBUY.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}